var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.71 10.29L18.71 9.29L18 9V4L17.71 3.29L14.71 0.29L14 0H10L9.29 0.29L6.29 3.29L6 4V5H8V4.41L10.41 2H13.58L15.99 4.41V9H6L5.29 9.29L4.29 10.29L4 11V19L4.29 19.71L7.29 22.71L8 23H16L16.71 22.71L19.71 19.71L20 19V11L19.71 10.29ZM18 18.58L15.59 20.99H8.42L6.01 18.58V11.41L6.42 11H17.59L18 11.41V18.58ZM13 12.99L14 13.99V15.99L13 16.99V18.99H11V16.99L10 15.99V13.99L11 12.99H13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockOpen);
export default __webpack_public_path__ + "static/1777458306/media/icon-lock-open.f81a06408fac79bc0bd3fef4c87f5468.svg";
export { ForwardRef as ReactComponent };